import React from 'react'
import { FormattedMessage } from 'react-intl'
import { DashboardOutlined, BarChartOutlined } from '@ant-design/icons'

const flatten = (items, key) => {
  const r = []

  items.forEach(el => {
    r.push(el)

    if (el[key]) {
      return r.push(...flatten(el[key], key))
    }
    return []
  })

  return r
}

const pcm = () => {
  const r = {}

  submenus.forEach(el => {
    r[el.key] = el.children.map(el => el.key)
  })

  return r
}

const menu = [
  {
    title: <FormattedMessage id="createOrder.menu.title.fast" />,
    key: 'createOrderFast',
    url: 'createOrderFast',
    icon: <DashboardOutlined />,
    roles: ['super-admin', 'admin', 'business'],
  },
  {
    title: <FormattedMessage id="createOrder.menu.title" />,
    key: 'createOrder',
    url: 'createOrder',
    icon: <DashboardOutlined />,
    roles: ['super-admin', 'admin', 'business'],
  },
  {
    title: <FormattedMessage id="dashboard.menu.title" />,
    key: 'trips',
    url: 'trips',
    icon: <BarChartOutlined />,
    roles: ['super-admin', 'admin', 'business'],
  },
  {
    title: <FormattedMessage id="upcomings.menu.title" />,
    key: 'upcomings',
    url: 'upcomings',
    icon: <BarChartOutlined />,
    roles: ['super-admin', 'admin', 'business'],
  },
  {
    title: <FormattedMessage id="people.menu.title" />,
    key: 'people',
    url: 'employee',
    icon: <BarChartOutlined />,
    roles: ['super-admin', 'admin', 'business'],
  },
  {
    title: <FormattedMessage id="invites.menu.title" />,
    key: 'invites',
    url: 'invites',
    icon: <BarChartOutlined />,
    roles: ['super-admin', 'admin', 'business'],
  },
  {
    title: <FormattedMessage id="finance.menu.title" />,
    key: 'finance',
    // url: 'finance',
    icon: <BarChartOutlined />,
    roles: ['super-admin', 'admin', 'business'],
    children: [
      {
        title: <FormattedMessage id="finance.menu.transactions" />,
        key: 'finance.transactions',
        url: '/finance/transactions',
      },
      // {
      //   title: <FormattedMessage id="finance.menu.billing" />,
      //   key: 'finance.billing',
      //   url: '/finance/billing',
      // },
      {
        title: <FormattedMessage id="cards.menu.title" />,
        key: 'cards.list',
        url: '/finance/cards',
      },
    ],
  },
  {
    title: <FormattedMessage id="settings.menu.title" />,
    key: 'settings',
    icon: <BarChartOutlined />,
    roles: ['super-admin', 'admin', 'business'],
    children: [
      {
        title: <FormattedMessage id="settings.menu.labels" />,
        key: 'settings_labels',
        url: '/settings/labels',
      },
      {
        title: <FormattedMessage id="settings.menu.rules" />,
        key: 'settings_rules',
        url: '/settings/rules',
      },
      {
        title: <FormattedMessage id="settings.menu.account" />,
        key: 'settings_account_edit',
        url: '/settings/account/edit',
      },
    ],
  },
]

const flat_menu = flatten(menu, 'children')

const submenus = menu.filter(el => el.children)

const parent_children_menu = pcm()

export { menu, flat_menu, submenus, parent_children_menu }
